const state = {
    // 初始值先从本地缓存读，读不到默认 16
    globalFontSize: localStorage.getItem('global_font_size') || 30,
    // 语音提示开关
    voiceTip: localStorage.getItem('voice_tip') || true
}

const mutations = {
    SET_FONT_SIZE(state, size) {
        state.globalFontSize = size
        localStorage.setItem('global_font_size', size)
        // 关键步骤：直接修改根元素的样式
        document.documentElement.style.setProperty('--global-font-size', size + 'px')
    },
    SET_VOICE_TIP(state, tip) {
        state.voiceTip = tip
        localStorage.setItem('voice_tip', tip)
    }
}

const actions = {
    // 改变全局字体大小
    changeFontSize({ commit }, size) {
        commit('SET_FONT_SIZE', size)
    },
    // 改变语音提示开关
    changeVoiceTip({ commit }, tip) {
        commit('SET_VOICE_TIP', tip)
    }
}
// 暴露
export default {
    namespaced: true,
    state,
    mutations,
    actions
}